import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-policy-underwriter-dialog',
  templateUrl: './delete-policy-underwriter-dialog.component.html',
  styleUrls: ['./delete-policy-underwriter-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatDialogModule, 
    MatButtonModule
  ]
})
export class DeletePolicyUnderwriterDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DeletePolicyUnderwriterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onDeleteClick() {
    this.dialogRef.close(true);
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }
}